import React from 'react';

export const Question = ({ number, children }) => {
    return (<div className="ncd-question">
        {number && <span className="ncd-question-no">{number}</span>}
        <div>{children}</div>
    </div>);
};


// WEBPACK FOOTER //
// ./src/pages/NotificationChore/Question.js